export * from './lib/accounts-redirection.service.module';

export { AccredibleAccountsRedirectionService } from './lib/accounts-redirection.service';
export { AccountsRedirectionKey } from './lib/accounts-redirection.model';
